module.exports = __webpack_public_path__ + "media/images/favicons/72x72-0ebd4519f66d61892eb67ef4541d59e1.png";